import React from "react";

const Arrow = () => {
  return (
    <path d="M19.2484912,16 L7.69777502,4.16649791 C6.76740833,3.21335387 6.76740833,1.66800206 7.69777502,0.714858026 C8.62814172,-0.238286009 10.1365642,-0.238286009 11.0669309,0.714858026 L24.302225,14.2741801 C25.2325917,15.2273241 25.2325917,16.7726759 24.302225,17.7258199 L11.0669309,31.285142 C10.1365642,32.238286 8.62814172,32.238286 7.69777502,31.285142 C6.76740833,30.3319979 6.76740833,28.7866461 7.69777502,27.8335021 L19.2484912,16 Z" />
  );
};

export default Arrow;
